export const PathsEnum = {
  MAIN: '/',
  RESET_PASSWORD_ROOT: '/reset-password',
  SUCCESS_PAGE: '/success',
  SESSION_EXPIRED_PAGE: '/session-expired',
  EMAIL_VERIFICATION_PAGE: '/verify-email',
  CHANGE_EMAIL_PAGE: '/change-email',
  CHANGE_EMAIL_EXPIRE: '/change-email-expire',
  EMAIL_VERIFICATION_SUCCESS_PAGE: '/verify-email-success',
  EMAIL_VERIFICATION_FAILURE_PAGE: '/verify-email-failure',
};
